import { render } from "./EditStar.vue?vue&type=template&id=bb7c26ea&scoped=true"
import script from "./EditStar.vue?vue&type=script&lang=js"
export * from "./EditStar.vue?vue&type=script&lang=js"

import "./EditStar.vue?vue&type=style&index=0&id=bb7c26ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7c26ea"]])

export default __exports__